export const notificationVariantSelector = (state: any) =>
  state.notification.variant;
export const notificationMessageSelector = (state: any) =>
  state.notification.message;
export const notificationOpenSelector = (state: any) => state.notification.open;
